var React = require('react');
var ReactNative = require('react-native');


var Animated = require('./wrappers/Animated')

var Icon = require('./wrappers/ReUpIcon');

var Globals = require('./Globals');
var ModelConstants = require('./constants/ModelConstants.js');
var NetworkManager = require('./NetworkManager.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpIconButton = require('./ReUpIconButton.js');
var ShadowView = require('./ShadowView.js');
var ReUpText = require('./ReUpText');
var ArcMeter = require('./ArcMeter.js')

var {
  AppRegistry,
  StyleSheet,
  Text,
  View,
  Image,
  ScrollView,
  DeviceEventEmitter,
} = ReactNative;

var testData = [
            {
                "PassID": "1",
                "Name": "Facials",
                "Description": "Get 5 facials for the price of 4!",
                "RedeemQuantity": "5",
                "Cost": "100.00",
                "TaxRate": "0.13",
                "IsDisabled": "0",
                "IsDeleted": "0",
                "PassBlob": "{\"StartDate\": \"\", \"EndDate\": \"\", \"LimitPerCustomer\": \"\", \"PurchaseWithCredit\": \"\"}",
                "AmountCharged": "113.00"
            },
            {
                "PassID": "2",
                "Name": "Manicures",
                "Description": "Get 10 manicures for $200!",
                "RedeemQuantity": "10",
                "Cost": "200.00",
                "TaxRate": "0.13",
                "IsDisabled": "0",
                "IsDeleted": "0",
                "PassBlob": "{\"StartDate\": \"\", \"EndDate\": \"\", \"LimitPerCustomer\": \"\", \"PurchaseWithCredit\": \"\"}",
                "AmountCharged": "226.00",
                "StateEnum": "1",
                "RedeemQuantityRemaining": "6"
            },
            {
                "PassID": "3",
                "Name": "Unlimited Blows",
                "Description": "Subscribe now and get unlimited blows for $30 per month!",
                "RedeemQuantity": "10",
                "Cost": "30.00",
                "TaxRate": "0.13",
                "IsDisabled": "0",
                "IsDeleted": "0",
                "PassBlob": "{\"type\": \"1\"}",
                "AmountCharged": "33.90",
            }
        ]

var MK = require('./wrappers/react-native-material-kit-wrapper');

var {
  MKButton,
} = MK;

var Passes = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
      passes : []
    }
  },

  componentDidMount : function()
  {
    this.didUpdate();
  },

  didUpdate : function()
  {
    var thisThing = this;
    this.props.appManager.getDataType("Passes", (data) =>
    {
      thisThing.setState({passes:data});
      // thisThing.setState({passes:testData});
    })
  },

  didSelectPass : function(pass)
  {
    var thisPass = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;

    if ( pass.RedeemQuantityRemaining )
    {
      appActions.requestFeatureName("UsePass",{pass:pass})
    }
    else
    {
      appActions.requestFeatureName("AddPass",{pass:pass, passes:this})
    }
  },

  render: function()
  {
    var thisPass = this;
    var appManager = this.props.appManager;
    var locManager = this.props.appManager.getLocalizationManager();
    var user = appManager.currentUser();

    var instructionColor = appManager.getColorForKey("InstructionColor");
    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var primaryColor = appManager.getColorForKey("PrimaryColor");
    var profileMeterBackgroundColor = appManager.getColorForKey("SecondaryColor");
    if( profileMeterBackgroundColor == generalColor ) profileMeterBackgroundColor = appManager.getColorForKey("PrimaryColor",0.4);
    var profileMeterColor = appManager.getColorForKey("PrimaryColor");
    var selectOneToRedeemStr = locManager.localizedStringForKey("SELECT_PASS_TO_REDEEM_ALERT_BODY");

    var pointsLeftStatement = locManager.localizedStringForKey("POINTS_LEFT_STATEMENT");

    var passes = this.state.passes.sort(function(a,b)
    {
      if( a.StateEnum == '0' && b.StateEnum != '0' ) return 1;
      if( b.StateEnum == '0' && a.StateEnum != '0' ) return -1;

      return a.Cost - b.Cost;
    });

    var passesWithHeadings = [];
    var hasFoundPurchased = false;
    var hasFoundNonPurchased = false;
    var purchasedTitle = "Purchased";
    var forSaleTitle = "For Sale";
    for( var i = 0; i < passes.length; i++ )
    {
      var isPurchased = typeof passes[i].RedeemQuantityRemaining !== 'undefined';
      if( isPurchased && !hasFoundPurchased )
      {
        passesWithHeadings.push(purchasedTitle);
        hasFoundPurchased = true;
      }
      if( !isPurchased && !hasFoundNonPurchased )
      {
        passesWithHeadings.push(forSaleTitle);
        hasFoundNonPurchased = true;
      }

      passesWithHeadings.push(passes[i]);
    }

    var numUserPoints = user[ModelConstants.Points];
    return (
      <View style={styles.container}>
        { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }
        <View style={[styles.backgroundView, {width:this.state.layout.width, height:this.state.layout.height, backgroundColor: generalColor}]} />
        <ReUpScrollView ref={(c) => { this._ref_ptr = c; }} bounces={true} responder={this} featureName="Passes" isEmpty={passes.length <= 0}>

          {
            passesWithHeadings.map(function(pass, index)
            {
              if( typeof pass === "string" )
              {
                var moreProps = {};
                if( pass == purchasedTitle ) moreProps.alertMessage = selectOneToRedeemStr;
                return (
                  <View>
                    <View style={[styles.instructionContainer, {backgroundColor: instructionColor, color:instructionTitleColor}]}>
                      <View style={{alignSelf:'center'}}>
                        <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={[styles.instructionText, {color:instructionTitleColor}]}>
                          {pass}
                        </ReUpText>
                      </View>
                      <View style={{flex:1}} />
                      <ReUpIconButton type={3}
                        appManager={typeof appManager === 'undefined' ? null : appManager}
                        featureData={thisPass.props.featureData}
                        appActions={thisPass.props.appActions}
                        {...moreProps}
                        />
                    </View>
                    <ShadowView appManager={typeof appManager === 'undefined' ? null : appManager} layout={thisPass.state.layout} />
                  </View>
                  )
              }

              var isPurchased = typeof pass.StateEnum !== 'undefined' && pass.StateEnum == '1';
              var amountFontSize = 20;
              var type = typeof pass.PassBlob === 'undefined' || pass.PassBlob == null || typeof JSON.parse(pass.PassBlob).type === 'undefined' ? 0 : JSON.parse(pass.PassBlob).type;
              var leftText = locManager.localizedDollars(pass.Cost);
              var rightText = "";
              if( type == 0 )
              {
                rightText = pass.RedeemQuantity + " " + pass.Name;
              }
              else
              {
                rightText = locManager.localizedStringForKeyAndParams("PASS_SUBSCRIPTION_STATEMENT", [pass.Name]);
              }

              var fraction = 1;
              if( isPurchased )
              {
                // pass.RedeemQuantityRemaining = 10;
                // pass.RedeemQuantity = 100;
                rightText = pass.Name;
                fraction = parseFloat(pass.RedeemQuantityRemaining)/parseFloat(pass.RedeemQuantity);
                leftText = pass.RedeemQuantityRemaining + "/" + pass.RedeemQuantity;
                amountFontSize = 30 - (leftText.length > 3 ? (leftText.length - 3)*5 : 0);
              }

              return (
                <MKButton key={pass.PassId} style={[styles.passRowContainer,{opacity:1}]}
                  backgroundColor={'transparent'}
                  shadowRadius={2}
                  shadowOffset={{width:0, height:2}}
                  shadowOpacity={0.7}
                  shadowColor={'transparent'}
                  enabled={true}
                  onPress={() => {
                    thisPass.didSelectPass(pass);
                  }}
                  >
                  <View style={styles.passRow}>
                    {
                      isPurchased ?
                        <View style={{margin:5, width:110, height:110, alignItems:'center', justifyContent:'center'}}>
                          <ArcMeter fgColor={profileMeterColor} bgColor={profileMeterBackgroundColor} percentage={fraction} style={{width:100,height:100}}>
                            <View>
                              <ReUpText appManager={appManager} style={{fontSize:amountFontSize, color:generalTitleColor,
                                alignSelf:'center',
                                justifyContent:'center'}}>
                                {leftText}
                              </ReUpText>
                            </View>
                          </ArcMeter>
                        </View>
                      :
                        <View style={{margin:5, width:110, height:110, alignItems:'center', justifyContent:'center'}}>
                          <View><ReUpText appManager={appManager} style={[styles.passRedeemQuantity,{fontSize:amountFontSize, color:generalTitleColor}]}>
                            {leftText}
                          </ReUpText></View>
                        </View>
                    }

                    <View style={styles.passRightContainer}>
                      <ReUpText appManager={appManager} isTitle={true} style={[{color:generalTitleColor}]}>
                        {rightText}
                      </ReUpText>
                      <ReUpText appManager={appManager} style={[styles.passDescription, {color:generalTitleColor}]}>
                        {pass.Description}
                      </ReUpText>
                    </View>
                  </View>
                  <ShadowView appManager={typeof appManager === 'undefined' ? null : appManager} layout={thisPass.state.layout} />
                </MKButton>
              )
            })
          }
        </ReUpScrollView>
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
  instructionContainer: {
    backgroundColor:'blue',
    flexDirection:'row',
  },
  instructionText: {
    margin: 10,
  },
  backgroundView: {
    position: 'absolute',
  },
  passRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  passDivider: {
    height: 1,
    backgroundColor: 'grey'
  },
  passLeftContainer: {
    width:100,
    height:100,
    paddingTop:8,
    marginLeft:4,
    marginRight:4,
    paddingBottom:8,
    justifyContent:'center',
    alignItems:'center',
    alignSelf:'center',
  },
  passRedeemQuantity: {
    fontSize: 34,
    alignSelf: 'center',
    justifyContent: 'center',
  },
  passRightContainer: {
    flex: 1,
    justifyContent: 'center',
    paddingRight: 8,
    paddingBottom: 4,
    paddingTop: 4
  },
  passDescription: {
    padding: 0,
    margin: 0,
    opacity: .8,
  }
});

Passes.getCards = function(featureData, appActions, data)
{
  var appManager = appActions._appManager;
  var isLoggedIn = appManager.isLoggedIn();

  if( !isLoggedIn ) return [];
  else
  {
    var user = appManager.currentUser();
    var points = parseFloat(user[ModelConstants.Points]);
    var passes = typeof data.Passes !== 'undefined' ? data.Passes : [];
    var passes = typeof data.Passes !== 'undefined' ? data.Passes.sort(function(a,b)
    {
      return parseFloat(b.Cost) - parseFloat(a.Cost);
    }) : [];
    if( typeof passes === 'undefined' || passes == null || passes.length <= 0 ) return [];

    // get date acheived
    var sortOrder = -1;

    sortOrder -= 1000; // reduce by a second so that it is above transaction history

    var didSelect = function() {appActions.requestFeatureName("Passes")};
    var iconName = featureData.data.icon.replace("fa-", "")
    return [{
      didSelect : didSelect,
      title : featureData.data.title,
      body1 : featureData.data.tip,
      icon : iconName,
      cardType : 0,
      sortOrder : sortOrder
    }];
  }
}

Passes.dataDependencies = ["Users", "Passes"];

module.exports = Passes;
